// CSS-Modul-Klassen kommen wegen `noUncheckedIndexedAccess` als `string | undefined`
// heraus; manche Konsumenten (z. B. `Link`) nehmen wegen `exactOptionalPropertyTypes` kein
// `undefined`. Deshalb wird hier einmal aufgeloest und zusammengesetzt (R9-3: vorher an drei
// Stellen wortgleich kopiert, siehe `preflight-b2.md` Befund D6).
export function klasse(...namen: (string | false | undefined)[]): string {
  return namen.filter(Boolean).join(' ');
}
